<template>
   <div>
      <form class="row justify-content-center p-details" action="POST" v-on:submit.prevent="save('form-1')" data-vv-scope="form-1">
        <div class="col-12">
          <div class="form-group custom-input">
                  <div class="para">I have completed Diploma </div> 
                  <v-select label="boardName" :class="{'form-error': errors.has('board')}" v-model="selectedBoard" :options="boardList" :error-messages="errors.collect('board')" v-validate="'required|not_in:Select'" data-vv-name="board" name="board" placeholder="Select Board"  required></v-select>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para">On date</div>
                  <date-picker name="dateofResult" v-model="startTime" :option="option" :limit="limit" v-validate="'required'" :class="{'form-error': errors.has('dateofResult'),'input': true, 'is-danger': errors.collect('dateofResult') }" data-vv-name="dateofResult" data-vv-validate-on="change" ></date-picker>
                  <sup>
                  <i class="mdi mdi-star text-danger"></i>
                  </sup>
                  <div class="para"> having RollNo / Seat No </div>
                  <input name="Seat No" class="form-control-alt col-6" id="namelc" v-model="educationDetails.seatNumber" v-validate="'required'" :class="{'form-error': errors.has('form-1.Seat No'),'input': true, 'is-danger': errors.has('form-1.Seat No') }" type="text" placeholder="Roll/Seat No" >
                  <div class="para">.Completed Diploma with </div>
                  <input name="Total Mark" class="form-control-alt" id="totalMark" v-model="educationDetails.totalMarksObtained" v-validate="'required'" :class="{'form-error': errors.has('form-1.Total Mark'),'input': true, 'is-danger': errors.has('form-1.Total Mark') }" type="text" placeholder="Mark Obtained">
                  <div class="para">Out of</div>
                  <input name="Out Of" v-validate="'required'" class="form-control-alt" id="outOf" v-model="educationDetails.outOf" :class="{'form-error': errors.has('form-1.Out Of'),'input': true, 'is-danger': errors.has('form-1.Out Of') }" type="text" placeholder="Out Of" >
                  <div class="para">Marksheet No</div>
                  <input name="Marksheet No" v-validate="'required'" class="form-control-alt" id="panNo" v-model="educationDetails.marksheetNo" :class="{'form-error': errors.has('form-1.Marksheet No'),'input': true, 'is-danger': errors.has('form-1.Marksheet No') }" type="text" placeholder="Marksheet No" >
                  <br>
                  <br>
                  <button type="button" @click="saveDiplomaDetails"  class="btn btn-success-alt text-center">Save</button>
          </div>
        </div>
      </form>
   </div>
</template>
<script>
import myDatepicker from 'vue-datepicker2'
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'DiplomaDetails',
  components: {
    'date-picker': myDatepicker
  },
  data () {
    return {
      startTime: '',
      educationDetails: {},
      selectedBoard: null,
      boardList: [],
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'DD/MM/YYYY',
        placeholder: 'Select Date Of Birth',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          border: '2px solid #fff',
          'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          'border-radius': '2px',
          color: '#5F5F5F'
        }
      },
      limit: [{
        type: 'fromto',
        from: '1960-02-01',
        to: '2018-02-23'
      }]
    }
  },
  methods: {
    getBoardDetails () {
      var self = this
      console.log('get board details')
      axios.get('r/candidateProfile/getBoardDetails')
            .then(function (response) {
              if (response.status === 200) {
                self.boardList = response.data
                self.getUserDiplomaDetails()
                // self.certificationList.push(self.defaultObj)
              }
            })
            .catch(function () {
              self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
                theme: 'bubble',
                duration: 2000
              })
            })
    },
    getUserDiplomaDetails () {
      var self = this
      var profileUser = this.$store.state.candidateProfile.profileUser
      axios.get('r/candidateProfile/getDiplomaDetails/' + profileUser)
            .then(function (response) {
              if (response.status === 200) {
                self.educationDetails = response.data
                for (var i in self.boardList) {
                  if (self.boardList[i].boardName === self.educationDetails.board) {
                    self.selectedBoard = self.boardList[i]
                  }
                }
                if (self.educationDetails.dateOfResult !== undefined && self.educationDetails.dateOfResult !== null && self.educationDetails.dateOfResult !== '') {
                  console.log(self.educationDetails.dateOfResult)
                  var parts = self.educationDetails.dateOfResult.split('/')
                  self.startTime = moment(String(new Date(parts[2], parts[1] - 1, parts[0]))).format('DD/MM/YYYY')
                }
                // self.certificationList.push(self.defaultObj)
              }
            })
            .catch(function () {
             /*  self.$toasted.error(self.$t('candidateProfile.certification.toastrErrorFetchingCertificationList'), {
                theme: 'bubble',
                duration: 2000
              }) */
            })
    },
    saveDiplomaDetails () {
      var profileUser = this.$store.state.candidateProfile.profileUser
      this.$validator.validate().then((result) => {
        if (result) {
          this.educationDetails.board = this.selectedBoard.boardName
          this.educationDetails.dateOfResult = moment(String(this.startTime)).format('DD/MM/YYYY')
          axios.post('r/candidateProfile/saveDiplomaDetails/' + profileUser, this.educationDetails)
              .then(response => {
                if (response.status === 200) {
                  this.$toasted.success('Diploma Details Save Successfuly', {
                    theme: 'bubble',
                    duration: 2000
                  })
                  return true
                }
              })
              .catch(e => {
                console.log(e)
                return false
              })
        } else {
          this.$toasted.error('Please Enter Required data', {
            theme: 'bubble',
            duration: 2000
          })
        }
      }).catch(e => {
        this.$toasted.error('Oops Something goes wrong', {
          theme: 'bubble',
          duration: 2000
        })
      })
    }
  },
  created: function () {
    this.getBoardDetails()
  }
}
</script>
<style lang='scss'>
  .p-details{
    .qrcode-reader__camera {
      // border-radius:4px;
      display:inline-block;
      //  height: 100%;
  width: 50% ; 
  border-radius:5px;
    }
.qrClass {
  height: 100%;
  // width: 100% ; 
  }
  .uppercase{
 text-transform: uppercase;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/registration/diplomaDetails.vue